import { Link } from '@mui/material';
import dayjs from 'dayjs';
import { getPhoneNumberWihKey } from './profile-utils';

export const getDisplayValueFromInfo = (info) => {
    if (!info)
        return '';

    if (info.countryCode) {
        return getPhoneNumberWihKey(info);
    } else if (info.infoType === 'address') {
        let name = "";

        if (info.country)
            name = info.country

        if (info.state)
            name += " - " + info.state

        if (info.city)
            name += " - " + info.city

        return name;
    } else if (info.infoType === 'date') {
        return dayjs(info.infoValue).format('ddd D, MMM YYYY');
    } else if (info.infoType === 'URL') {
        return <Link rel='noopener noreferrer' target="_blank" href={info.infoValue}>{info.infoValue}</Link>;
    } else {
        return info.infoValue.length > 50 ? info.infoValue?.substring(0, 50) + '...' : info.infoValue;
    }
}